import React, { useState } from "react";
import { getAppStatus,getIncident } from "../../API/api";
import { Spin, Drawer } from "antd";
import moment from "moment";
export default function StatusPage() {
  const [status, setStatus] = useState(true);
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [incidentData, setIncidentData] = useState(null);
  const fetchStatus = async () => {
    try {
      setLoading(true);
      setData(null);
      const response = await getAppStatus();
      if (response?.data?.success) {
        setData(response.data.data[0]);
        response.data.data[0].currentStatus.forEach((service) => {
          if (service.type.length > 0) {
            setStatus(false);
          }
        });
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getStatus = (type) => {
    let status = "";
    data.currentStatus.forEach((service) => {
      if (service.service === type) {
        if (service.type.length === 0) {
          status = "no issues";
        } else {
          status = service.type[0];
        }
      }
    });
    return status;
  };
  const detailedIncident=(type)=>{
    setIncidentData(null)
    setOpen(true);
    let date = moment(new Date()).format('YYYY-MM-DD');
    getIncident(date,type).then((res) => {
      setIncidentData(res.data.data);
    }).catch((err) => {
      console.log(err);
    });
  }
  const statusIcon = (type) => {
    switch (type) {
      case "no issues":
        return (
          <i
            className="fa fa-check-circle"
            style={{ color: "#28a745", fontSize: "24px" }}
          ></i>
        );
      case "Maintenance":
        return (
          <i
            className="fa fa-wrench"
            style={{ color: "#1E64A3", fontSize: "24px" }}
          ></i>
        );
      case "Notice":
        return (
          <i
            className="fa fa-flag"
            style={{ color: "#3F46AD", fontSize: "24px" }}
          ></i>
        );
      case "Incident":
        return (
          <i
            className="fa fa-exclamation-triangle"
            style={{ color: "#ffc107", fontSize: "24px" }}
          ></i>
        );
      case "Outage":
        return (
          <i
            className="fa fa-minus-circle"
            style={{ color: "red", fontSize: "24px" }}
          ></i>
        );
    }
  };
  React.useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <>
      {status && !isLoading && (
        <div
          style={{
            textAlign: "center",
            fontSize: "28px",
            color: "#5c667b",
            fontWeight: "200",
          }}
        >
          <div>
            <i className="fa fa-check-circle" style={{ color: "#28a745" }}></i>
          </div>
          <span>Vizerto is up and running</span>
        </div>
      )}
      {!status && !isLoading && (
        <div
          style={{
            textAlign: "center",
            fontSize: "28px",
            color: "#5c667b",
            fontWeight: "200",
          }}
        >
          <div>
            <i className="fa fa-minus-circle" style={{ color: "red" }}></i>
          </div>
          <span>Sorry, we are having issues</span>
        </div>
      )}
      <br />
      {!isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #eaecef",
            color: "#5c667b",
            padding: "20px",
            fontSize: "16px",
            fontWeight: "300",
            borderStartStartRadius: "8px",
            borderStartEndRadius: "8px",
          }}
        >
          <div>
            <span>Current Status by Service</span>
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            <span>
              <i
                className="fa fa-check-circle"
                style={{ color: "#28a745" }}
                aria-hidden="true"
              ></i>
              &nbsp; No issues
            </span>
            <span>
              <i
                className="fa fa-wrench"
                style={{ color: "#1E64A3" }}
                aria-hidden="true"
              ></i>
              &nbsp; Maintenance
            </span>
            <span>
              <i
                className="fa fa-flag"
                style={{ color: "#3F46AD" }}
                aria-hidden="true"
              ></i>
              &nbsp; Notice
            </span>
            <span>
              <i
                className="fa fa-exclamation-triangle"
                style={{ color: "#ffc107" }}
                aria-hidden="true"
              ></i>
              &nbsp;Incident
            </span>
            <span>
              <i
                className="fa fa-minus-circle"
                style={{ color: "red" }}
                aria-hidden="true"
              ></i>
              &nbsp;Outage
            </span>
          </div>
        </div>
      )}
      {data !== null && !isLoading && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "18px",
              width: "100%",
            }}
          >
            <div
              style={{
                borderInlineStart: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Login/SSO</div>
                {getStatus("Login/SSO") !== "no issues" ? <div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Login/SSO")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Login/SSO"))}</div>
            </div>
            <div
              style={{
                borderInline: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Notifications</div>
                {getStatus("Notifications") !== "no issues" ?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Notifications")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Notifications"))}</div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "18px",
              width: "100%",
            }}
          >
            <div
              style={{
                borderInlineStart: "1px solid #eaecef",
                borderBlockStart: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Scheduler</div>
                {getStatus("Scheduler") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Scheduler")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Scheduler"))}</div>
            </div>
            <div
              style={{
                borderInline: "1px solid #eaecef",
                borderBlockStart: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Routing</div>
                {getStatus("Routing") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Routing")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Routing"))}</div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "18px",
              width: "100%",
            }}
          >
            <div
              style={{
                borderInlineStart: "1px solid #eaecef",
                borderBlock: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>
                  Attachment Preview/Download
                </div>
                {getStatus("Attachment Preview/Download") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Attachment Preview/Download")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Attachment Preview/Download"))}</div>
            </div>
            <div
              style={{
                border: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Search</div>
                {getStatus("Search") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Search")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Search"))}</div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "18px",
              width: "100%",
            }}
          >
            <div
              style={{
                borderInlineStart: "1px solid #eaecef",
                borderBlockEnd: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                borderEndStartRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Apps/Integrations/APIs</div>
                {getStatus("Apps/Integrations/APIs") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Apps/Integrations/APIs")}
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Apps/Integrations/APIs"))}</div>
            </div>
            <div
              style={{
                borderInline: "1px solid #eaecef",
                borderBlockEnd: "1px solid #eaecef",
                color: "#5c667b",
                width: "50%",
                padding: "20px",
                borderEndEndRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <div>
                <div style={{ fontWeight: "400" }}>Administration</div>
                { getStatus("Administration") !== "no issues"?<div style={{ fontWeight: "200", fontSize: "14px" }}>
                  Having some issues{" "}
                  <span onClick={()=>detailedIncident("Administration")}
                  
                    style={{ textDecoration: "underline",cursor:'pointer', fontWeight: "400" }}
                  >
                    View details
                  </span>
                </div>:<div style={{ fontWeight: "200", fontSize: "14px" }}>No known issues</div>}
              </div>
              <div>{statusIcon(getStatus("Administration"))}</div>
            </div>
          </div>
          <br />
          <br />
          <div
            style={{
              textAlign: "end",
              fontSize: "18px",
              color: "#5c667b",
              fontWeight: "400",
            }}
          >
            <span>
              Uptime for the current quarter: {data.currentQuarterUptime}%
            </span>
          </div>
        </>
      )}
      {isLoading && (
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            color: "#5c667b",
            fontWeight: "200",
            marginTop: "30vh",
          }}
        >
          <span>
            <Spin size="large" />
          </span>
        </div>
      )}
      <Drawer
        title={<div style={{ color: "#5c667b",fontSize:'20px', fontWeight: "400" }}>Incident Details</div>}
        placement="right"
        onClose={() => setOpen(false)}
        open={isOpen}
        width={"40%"}
        bodyStyle={{ padding: "20px" }}
      >
        {incidentData===null && <div style={{marginTop:'40vh', textAlign:'center'}}>
          <Spin size="large" spinning tip="Loading..."></Spin>
        </div>}
        {incidentData!== null && incidentData.length===0 && <div style={{marginTop:'40vh', textAlign:'center'}}>
          <span style={{color:'#5c667b', fontSize:'20px',fontWeight:'300'}}>No incidents found for this service</span>
        </div>}
        {incidentData!== null && incidentData.length > 0 && <div style={{}}>
         { incidentData.map((incident, index) => (
            <>
            <div style={{ fontSize: "16px", color: "#5c667b", marginBottom: "10px", fontWeight: "300" }}>Service Name: <span style={{fontWeight:'400'}}>{incident.services[0]}</span></div>
            <br/>
            <div key={index} style={{ marginBottom: "20px", border: "1px solid #eaecef", borderRadius: "8px", padding: "15px" }}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                <div style={{ fontSize: "18px", fontWeight: "400", color: "#5c667b",display:'flex' }}>
               {statusIcon(incident.type)}&nbsp;&nbsp;{incident.title}-({incident.type})
               {/* <div>
                {`(${incident.title})`}
               </div> */}
              </div>
              <div style={{ fontSize: "16px", color: "#5c667b", marginBottom: "10px", fontWeight: "300" }}>
                {moment(incident.dateReported).format("YYYY-MM-DD ")}
                {/* <div>
                  Status: <span style={{fontWeight:'400'}}>{incident.status}</span>
                </div> */}
              </div>
              </div>
              <div style={{ fontSize: "16px", color: "#5c667b", fontWeight: "300",marginBottom: "10px" }}>
                Status: {incident.status}
              </div>
              <div style={{ fontSize: "16px", color: "#5c667b", fontWeight: "300" }}>
                Issue: {incident.notes[0].body}
              </div>
            </div>
            </>
          ))}
        </div>}
      </Drawer> 
    </>
  );
}
